import React, { FC } from "react";
import * as Styled from "@/components/AdvantageOfVf/AdvantageOfVf.styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { IAdvantageOfVf } from "@/components/AdvantageOfVf/AdvantageOfVf.types";
import Informing from "@/components/AdvantageOfVf/Informing/Informing";

const AdvantageOfVf: FC<IAdvantageOfVf> = () => {
  return (
    <Styled.Wrapper>
      <Informing />
    </Styled.Wrapper>
  );
};

export default AdvantageOfVf;
